export default __webpack_public_path__ + "static/media/logo.758b4053.svg";